var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.count)?_c('div',{staticClass:"waiting-badge red",style:(_setup.styles)},[_vm._v(_vm._s(_setup.props.count))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }